import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class ValidationLinkService {

  constructor(private httpClient: HttpClient) { }

  sendResetPasswordLink(email: string) {
    return this.httpClient.post<string>(`${environment.validationUrl}/sendResetPasswordLink`, { email });
  }

  sendAccountValidation(email: string) {
    return this.httpClient.post<string>(`${environment.validationUrl}/sendAccountValidationLink`, { email });
  }
}
